'use client';

const Spinner = () => {
  return (
    <span
      className='inline-block h-10 w-10 animate-spin rounded-full border-2 border-sand-500/70 border-t-transparent dark:border-sand-400/80 dark:border-t-transparent'
      aria-label='Loading'
      role='status'
    />
  );
};

export default Spinner;
